var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoProduct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.6219V7.37812C20.9993 7.2446 20.9634 7.11362 20.8959 6.99841C20.8284 6.88319 20.7317 6.78781 20.6156 6.72187L12.3656 2.08125C12.2545 2.01706 12.1284 1.98328 12 1.98328C11.8716 1.98328 11.7455 2.01706 11.6344 2.08125L3.38437 6.72187C3.26827 6.78781 3.1716 6.88319 3.10411 6.99841C3.03663 7.11362 3.00072 7.2446 3 7.37812V16.6219C3.00072 16.7554 3.03663 16.8864 3.10411 17.0016C3.1716 17.1168 3.26827 17.2122 3.38437 17.2781L11.6344 21.9187C11.7455 21.9829 11.8716 22.0167 12 22.0167C12.1284 22.0167 12.2545 21.9829 12.3656 21.9187L20.6156 17.2781C20.7317 17.2122 20.8284 17.1168 20.8959 17.0016C20.9634 16.8864 20.9993 16.7554 21 16.6219V16.6219Z",
    stroke: "#475569",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8969 6.99377L12.0844 12L3.10312 6.99377",
    stroke: "#475569",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0844 12L12 22.0125",
    stroke: "#475569",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoProduct);
export default __webpack_public_path__ + "static/media/ico_product.c2b29e7bdc52742ed8c4b9f13d1fd83f.svg";
export { ForwardRef as ReactComponent };